export function saveAsFile(filename, data) {
    const blob = new Blob([JSON.stringify(data)], {
        type: 'application/json',
    });
    const link = document.createElement('a');
    link.download = filename;
    link.href = window.URL.createObjectURL(blob);
    link.click();
}
